<template>
  <view-container
    header
    title="OCE Play"
    class="view-oce-play"
    subtitle="Integre sua área de membros da plataforma OCE Play à Blitzpay."
    :breadcrumbs="breadcrumbs"
  >
    <table-header @add="add" @dispatch="dispatch" @searching="searching" />

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <template v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-9 mx-auto"
              src="@/assets/images/home/welcome.png"
            />
            <h5>Você ainda não adicionou nenhuma integração</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <!-- Desktop area -->
      <template v-else>
        <data-table
          new-design
          class="d-none d-lg-block"
          columnsFr="1fr 1fr 1fr 0.4fr 0.4fr 0.2fr"
          :columns="columns"
          :data="integrationList"
        >
          <template #default="{ item }">
            <div class="crop">
              <span>
                {{ item.product_name }}
              </span>
            </div>
            <div class="crop">
              <span>
                {{ item.description }}
              </span>
            </div>
            <div>
              <span :class="statusClass(item.url_status === 'enable')">
                {{
                  item.url_status == "enable" ? "Compra aprovada" : "Reembolso"
                }}
              </span>
            </div>
            <span>{{ item.internal_id }}</span>
            <div>
              <span :class="statusClass(item.status)">
                {{ item.status ? "Ativo" : "Inativo" }}
              </span>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @edit="edit(item)"
                @delete="submitDelete(item)"
                @change-status="changeStatus(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- Desktop area -->
        <!-- Mobile area -->
        <data-table
          new-design
          class="d-lg-none"
          :columns="['', '']"
          :data="integrationList"
        >
          <template #default="{ item }">
            <div class="responsive-table">
              <span>
                <strong>Produto: </strong>
                {{ item.product_name }}
              </span>
              <span>
                <strong>Descrição: </strong>
                {{ item.description }}
              </span>
              <span>
                <strong>Quando encaminhar: </strong>
                <span :class="statusClass(item.url_status === 'enable')">
                  {{
                    item.url_status == "enable"
                      ? "Compra aprovada"
                      : "Reembolso"
                  }}
                </span>
              </span>
              <span>
                <strong>ID externo: </strong>
                {{ item.internal_id }}
              </span>
              <span>
                <strong>Status: </strong>
                <strong :class="statusClass(item.status)">
                  {{ item.status ? "Ativo" : "Inativo" }}
                </strong>
              </span>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @edit="edit(item)"
                @delete="submitDelete(item)"
                @change-status="changeStatus(item)"
              />
            </div>
          </template>
        </data-table>
      </template>
      <!-- Mobile area -->
      <div class="d-flex justify-content-end my-5">
        <paginator
          v-show="integrationList.length"
          ref="paginator"
          :pagination="pagination"
          @on-update="dispatch"
        />
      </div>
    </template>

    <integration-modal v-model="modal" title="OCE Play">
      <oce-play-modal
        :integrationToEdit="integrationToEdit"
        @close="modal = false"
        @update-list="dispatch"
      />
    </integration-modal>
  </view-container>
</template>
<script>
import OcePlayModal from "@/components/tools/modals/member-area/OcePlay.vue";
import IntegrationsMixin from "@/mixins/integration.js";

export default {
  mixins: [IntegrationsMixin],
  components: {
    OcePlayModal
  },
  data() {
    return {
      integration: "oceplay",
      columns: [
        "Produto",
        "Descrição",
        "Quando encaminhar",
        "ID externo",
        "Status",
        ""
      ],
      breadcrumbs: [
        { title: "Ferramentas", link: "tools" },
        { title: "Área de membros", link: "tools-member-area" },
        { title: "OCE Play" }
      ]
    };
  }
};
</script>
<style></style>
